import React from "react";

const StyledH1Heading = ({ children, font }) => {
  return (
    <h1 className={`text-h1 font-star-jedi lowercase leading-[110%] ${font}`}>
      {children}
    </h1>
  );
};

export default StyledH1Heading;
